export default {"src":"/_next/static/media/aboutUs2.9b604638.svg","height":979,"width":1440};